import { DrupalTerm } from '@nx-icilalune/drupal-types';
import { Expose, Transform } from 'class-transformer';

export class TypeTerm extends DrupalTerm {
  public static readonly type = 'term--types';
}

export class TechnologyTerm extends DrupalTerm {
  public static readonly type = 'term--technologies';

  @Transform(({ obj }) => {
    return obj?.attributes?.icon_id || undefined;
  })
  @Expose()
  iconId!: string;
}

export class DomainTerm extends DrupalTerm {
  public static readonly type = 'term--domains';
}

export class SolutionTerm extends DrupalTerm {
  public static readonly type = 'term--solutions';
}

export class BusinessUnitTerm extends DrupalTerm {
  public static readonly type = 'term--business_unit';
}

export class ColorTerm extends DrupalTerm {
  public static readonly type = 'term--colors';
}

export class PageTemplateTerm extends DrupalTerm {
  public static readonly type = 'taxonomy_term--page_template';
}
